import { Line, mixins } from 'vue-chartjs';
// eslint-disable-next-line
import chartjsPluginAnnotation from "chartjs-plugin-annotation";
const { reactiveProp } = mixins;

export default {
    extends: Line,
    mixins: [reactiveProp],
    props: ['chartData', 'baseValue'],
    mounted () {
        console.log(this.baseValue);
        this.renderChart(this.chartData,  {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                xAxes: [{
                    gridLines: {
                        drawOnChartArea: false
                    }
                }],
                yAxes: [{
                    gridLines: {
                        drawOnChartArea: false
                    }
                }]
            },
            annotation: {
                annotations: [
                    {
                        // drawTime: "afterDatasetsDraw",
                        // id: "hline",
                        type: "line",
                        mode: "horizontal",
                        scaleID: "y-axis-0",
                        value: this.baseValue,
                        borderColor: "#EA8D78",
                        borderWidth: 1,
                        label: {
                            backgroundColor: "#EA8D78",
                            content: "Your Investment",
                            enabled: true
                        }
                    }
                ]
            }
        });
    }
}